/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Observable } from 'rxjs';

import { GridLayout, ColumnEnableConditions } from './grid-layout';

export abstract class GridLayoutService {
  abstract get(name: string, columnEnableConditions?: ColumnEnableConditions): Observable<GridLayout>;

  abstract getJobGrids(name: string, columnEnableConditions?: ColumnEnableConditions): Observable<GridLayout>;

  abstract update(layout: GridLayout): Observable<GridLayout>;
}
